import React from "react";
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import "./bike-example.css"

function App() {

  return (
    <>
      <motion.div className="page bike-example" key="loading" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
        <div className="cesta">
          <NavLink to="/#kola"><button><span>KOLA</span></button></NavLink>
          <NavLink to={"/#kola"} ><button><span>{"LOADING"}</span></button></NavLink>
          <button className="cesta-active"><span>{"LOADING"}</span></button>
        </div>


        <h1 className="bike-seznam-loading">Načítání</h1>
        <h2>{""}</h2>
        <div className="bike-example-loading-image" />

        <div className="bike-example-size-loading">
        </div>
      </motion.div>
    </>
  );
}

export default App;
